import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-checkradio',
  templateUrl: './checkradio.component.html',
  styleUrls: ['./checkradio.component.scss']
})
export class CheckradioComponent  {
  @Input() id: string;
  @Input() name: string;
  @Input() label: string;
  @Input() checked: boolean;
}
